import React from 'react';

import useOrchestratorSubmission from '../lib/useOrchestratorSubmission';

const withWizardStep = (WrappedComponent) => {
  const WithWizardStep = (props) => {
    const { onNext, orchestratorData = {} } = props;

    const { mutateAsync: mutateOrchestratorData, isPending: orchestratorLoading } =
      useOrchestratorSubmission({
        orchestratorData,
        onNext,
        invalidateQueryKey: ['wizardInstance', 'practice', 'wizard-overview']
      });

    return (
      <WrappedComponent
        {...props}
        orchestratorLoading={orchestratorLoading}
        mutateOrchestratorData={mutateOrchestratorData}
      />
    );
  };

  WithWizardStep.displayName = `withWizardStep(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithWizardStep;
};

export default withWizardStep;
